import React, { PropTypes } from 'react';

const rightArrow = (<path d="M24.3,21.5c0,0.5-0.2,1.1-0.6,1.5L4.3,42.3c-0.8,0.8-2.2,0.8-3,0s-0.8-2.2,0-3l17.8-17.8L1.3,3.7c-0.8-0.8-0.8-2.2,0-3
  s2.2-0.8,3,0L23.6,20C24.1,20.4,24.3,21,24.3,21.5"/>);

const leftArrow = (
  <g transform="rotate(180, 12.5, 21.5)">
    { rightArrow }
  </g>
);

const Arrow = (props) => {
  const arrowStyle = {};
  if(props.verticalOffset) arrowStyle.marginTop = `${props.verticalOffset}px`;

  const arrow = props.direction === 'left' ? leftArrow : rightArrow;
  return (
    <svg width={25} height={43} fill="#FFFFFF" viewBox="0 0 25 43" version="1.1" xmlns="http://www.w3.org/2000/svg" style={arrowStyle}>
      { arrow }
    </svg>);
};

Arrow.propTypes = {
  direction: PropTypes.string.isRequired,
  verticalOffset: PropTypes.number,
};

export default Arrow;



/** WEBPACK FOOTER **
 ** ./shared-components/FadeCarouselSide/components/Arrow.js
 **/